// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// Ensure Bootstrap loads first so our app styles can override it
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import store from "./store/store";
import { AuthProvider } from "./contexts/AuthContext";
import { PaymentProvider } from "./contexts/PaymentContext";
import { ChatProvider } from "./contexts/ChatContext";
import { validateEnvironment } from "./env-config";
import { initializeHotjar } from "./services/hotjar";
import { HelmetProvider } from "react-helmet-async";

// Validate environment variables before starting the app
try {
  validateEnvironment();
} catch (error) {
  console.error("Environment validation failed:", error);
  const errorMessage =
    error instanceof Error ? error.message : "Unknown configuration error";
  // Show a user-friendly error message
  document.body.innerHTML = `
    <div style="
      display: flex; 
      justify-content: center; 
      align-items: center; 
      height: 100vh; 
      font-family: Arial, sans-serif;
      background-color: #f8f9fa;
    ">
      <div style="
        text-align: center; 
        padding: 2rem; 
        background: white; 
        border-radius: 8px; 
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        max-width: 500px;
      ">
        <h2 style="color: #dc3545; margin-bottom: 1rem;">Configuration Error</h2>
        <p style="color: #6c757d; margin-bottom: 1rem;">${errorMessage}</p>
        <p style="color: #6c757d; font-size: 0.9rem;">
          Please contact your system administrator or check the deployment configuration.
        </p>
      </div>
    </div>
  `;
  throw error; // Re-throw to stop app initialization
}

// Initialize Hotjar for session replays
initializeHotjar();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <HelmetProvider>
        <AuthProvider>
          <PaymentProvider>
            <ChatProvider>
              <App />
            </ChatProvider>
          </PaymentProvider>
        </AuthProvider>
      </HelmetProvider>
    </BrowserRouter>
  </Provider>,
);
